<template>
  <el-select
      v-model="selectedValue"
      :multiple="multiple"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="clearable"
      :filterable="filterable"
      :remote="remote"
      :remote-method="remoteMethod"
      :popper-append-to-body="false"
      @visible-change="handleVisibleChange"
      @change="handleChange"
  >
    <el-option
        v-for="item in options"
        :key="item[valueKey]"
        :label="item[labelKey]"
        :value="item[valueKey]"
    />
  </el-select>
</template>

<script>
  export default {
    name: "SelectPage",
    props: {
      value: {
        type: [String, Number, Array],
        default: "",
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: "请选择",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      filterable: {
        type: Boolean,
        default: true,
      },
      remote: {
        type: Boolean,
        default: true,
      },
      valueKey: {
        type: String,
        default: "value",
      },
      labelKey: {
        type: String,
        default: "label",
      },
      // 分页参数
      pageSize: {
        type: Number,
        default: 30,
      },
      // 加载数据的方法
      loadData: {
        type: Function,
        required: true,
      },
      // 初始化参数
      initParams: {
        type: Object,
        default: () => {},
      },
      filterKey: {
        type: String,
        default: "filter",
      },
    },
    data() {
      return {
        selectedValue: this.value,
        options: [],
        loading: false,
        pageNum: 1,
        hasMore: true,
        query: "",
      };
    },
    watch: {
      value: {
        handler(newVal) {
          this.selectedValue = newVal;
        },
        deep: true,
      },
      selectedValue: {
        handler(newVal) {
          this.$emit("input", newVal);
        },
        deep: true,
      },
    },
    mounted() {
      // 初始化时加载第一页数据
      this.loadFirstPage();
    },
    methods: {
      // 加载第一页数据
      loadFirstPage() {
        this.pageNum = 1;
        this.options = [];
        this.hasMore = true;
        this.loadMore();
      },
      // 加载更多数据
      loadMore() {
        if (this.loading || !this.hasMore) return;
        this.loading = true;
        this.loadData({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          [this.filterKey]: this.query,
          ...this.initParams,
        }).then(res => {
          if (res.success) {
            const data = res.data.records || [];
            
            // 批量更新数据，减少DOM操作
            const newOptions = [...this.options, ...data];
            this.options = newOptions;
            
            if (this.options.length >= res.data.total) {
              this.hasMore = false;
            }
            this.pageNum++;
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      // 远程搜索方法
      remoteMethod(query) {
        this.query = query;
        this.loadFirstPage();
      },
      // 处理下拉框显示/隐藏
      handleVisibleChange(visible) {
        const dropdownList = this.$el.querySelector(".el-select-dropdown__wrap");
        if (!dropdownList) return;
        if (visible) {
          // 当下拉框显示时，添加滚动事件监听
          this.$nextTick(() => {
            if (dropdownList) {
              dropdownList.addEventListener("scroll", this.handleScroll);
            }
          });
        } else {
          // 当下拉框隐藏时，移除滚动事件监听
          if (dropdownList) {
            dropdownList.removeEventListener("scroll", this.handleScroll);
          }
        }
      },
      // 处理滚动事件，实现分页加载
      handleScroll(e) {
        const popper = e.target;
        if (popper.scrollTop + popper.clientHeight >= popper.scrollHeight - 10) {
          this.loadMore();
        }
      },
      // 处理选择变化
      handleChange(value) {
        const selectItem = this.options.filter(item => item[this.valueKey] === value)[0];
        this.$emit("change", selectItem);
      },
    },
  };
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>